const WIZARD_STEPS_DIGITIZE_DATA = {
  title: 'Digitizing Your Memories With FS is Easy as 1-2-3.',
  titleMob: 'How Ordering Works.',
  withoutPrice: true,
  titlesList: [
    {
      id: 1,
      text: 'Digitizing Your Memories',
      textMob: 'How ordering',
      secondText: '',
      secondTextMob: '',
      isTextReverse: false,
      isTextReverseMob: false,
      isTextColumn: false,
      isTextColumnMob: false,
      isLeft: true,
      isLeftMob: true,
      isRight: false,
      isRightMob: false,
      color: '#000',
      colorMob: '#000',
      isTextWithLine: true,
      isTextWithLineMob: false,
      isSecondTextWithLine: false,
      isSecondTextWithLineMob: false,
      firstTextLines: [{
        id: 1,
        isLeftLine: false,
        isRightLine: true,
        isTopLine: false,
        isBottomLine: false,
        color: '#000',
        isLineWithSquare: true,
        isLeftLineMob: true,
        isRightLineMob: false,
        isTopLineMob: false,
        isBottomLineMob: false,
        colorMob: '#000',
        isLineWithSquareMob: true,
      }],
      secondTextLines: [],
    },
    {
      id: 1,
      text: '',
      textMob: '',
      secondText: 'With FS is Easy as 1-2-3.',
      secondTextMob: 'works.',
      isTextReverse: false,
      isTextReverseMob: false,
      isTextColumn: false,
      isTextColumnMob: false,
      isLeft: false,
      isLeftMob: true,
      isRight: true,
      isRightMob: false,
      color: '#000',
      colorMob: '#000',
      isTextWithLine: false,
      isTextWithLineMob: false,
      isSecondTextWithLine: true,
      isSecondTextWithLineMob: true,
      firstTextLines: [],
      secondTextLines: [{
        id: 1,
        isLeftLine: true,
        isRightLine: false,
        isTopLine: false,
        isBottomLine: false,
        color: '#000',
        isLineWithSquare: false,
        isLeftLineMob: false,
        isRightLineMob: true,
        isTopLineMob: false,
        isBottomLineMob: false,
        colorMob: '#5F8AA4',
        isLineWithSquareMob: true,
      }],
    },
  ],
  dataForSteps: [
    {
      id: 1,
      title: 'Enter Media Quantity',
      mobTitle: 'Configure Your Project',
      description: 'First, enter the amount of analog media you have in our online ordering wizard. Each media type has its own easy ordering page.',
      mobDescription: 'First, enter the amount of tapes you have in our online ordering wizard.',
      src: '',
      mobSrc: '',
      isWithoutShadowCards: true,
    },
    {
      id: 2,
      title: 'Select Your Quality',
      mobTitle: 'Door-to-door service',
      description: 'Every digitizing service allows you to choose an optional Forever Gold upgrade that provides significant quality improvements.',
      mobDescription: 'Choose an optional Forever Gold upgrade that provides significant improvements.',
      src: '',
      mobSrc: '',
      isWithoutShadowCards: true,
    },
    {
      id: 3,
      title: 'Choose End Products',
      mobTitle: 'Relive the moments',
      description: 'You have a choice of quality options including USB drives, Forever Cloud services, Video DVDs, and handcrafted keepsakes.',
      mobDescription: 'You have a choice of USB drives, Forever Cloud services, Video DVDs, and more.',
      src: '',
      mobSrc: '',
      isWithoutShadowCards: true,
    },
  ],
  dataForButtons: [],
};

export default WIZARD_STEPS_DIGITIZE_DATA;
